export default class UnprocessableException extends Error {
  constructor(jsonResponse) {
    // El backend puede retornar errores en diferentes estructuras
    const errors = jsonResponse?.response?.error || jsonResponse?.response?.errorArray || jsonResponse?.errors || {};
    const message = jsonResponse?.response?.message || jsonResponse?.message || 'Error de validación';

    // Si hay errores específicos, mostrarlos
    const errorMessages = [];
    Object.values(errors).forEach(error => {
      if (Array.isArray(error)) {
        errorMessages.push(...error);
      } else {
        errorMessages.push(error);
      }
    });

    const finalMessage = errorMessages.length > 0 ? errorMessages.join(', ') : message;

    super(finalMessage);
    
    // Almacenar los errores originales para poder acceder a ellos por campo
    this.errors = errors;
    this.jsonResponse = jsonResponse;
  }
}
